<script setup lang="ts">
const { logout } = useLogout();

const { ADMIN_URL } = useRuntimeConfig().public;
const adminUrl = ADMIN_URL;
</script>

<template>
  <div class="bg-primary">
    <div
      class="relative flex min-h-dvh flex-col items-center md:justify-center"
    >
      <div class="absolute right-4 top-4">
        <PrimeButton rounded severity="secondary" @click="logout()">
          Wyloguj się
        </PrimeButton>
      </div>

      <NuxtLink
        to="/login"
        class="mb-6 flex w-full justify-start px-5 md:justify-center"
      >
      </NuxtLink>

      <PrimeCard>
        <template #content>
          <section class="flex items-center justify-center font-inter">
            <div class="max-w-screen-xl px-4 py-8 lg:px-6 lg:py-16">
              <div class="mx-auto max-w-screen-sm space-y-6 text-center">
                <slot />
                <PrimeButton
                  rounded
                  as="a"
                  :href="adminUrl"
                  target="_blank"
                  class="mr-2"
                >
                  Przejdź do panelu administratora
                </PrimeButton>
              </div>
            </div>
          </section>
        </template>
      </PrimeCard>
    </div>
  </div>
</template>
